var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtoile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.47483 0.140625L11.6319 6.77934H18.6122L12.965 10.8823L15.1221 17.521L9.47483 13.4181L3.8276 17.521L5.98465 10.8823L0.337419 6.77934H7.31778L9.47483 0.140625Z",
    fill: "#FFA146"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtoile);
export default __webpack_public_path__ + "static/media/étoile.38a044da217e5d992e898e5a7d7848bb.svg";
export { ForwardRef as ReactComponent };